<template>
  <div v-if="attendance">
    <vs-chip v-if="!attendance.is_absence" class="vs-chip-success text-white mt-2">
      Hadir
    </vs-chip>
    <vs-chip v-if="isOnTime" class="vs-chip-success text-white mt-2">
      Tepat Waktu
    </vs-chip>
    <vs-chip v-if="attendance.is_late" class="vs-chip-primary text-white mt-2">
      Terlambat
    </vs-chip>
    <vs-chip v-if="attendance.is_early" class="vs-chip-primary text-white mt-2">
      Pulang Lebih Awal
    </vs-chip>
    <vs-chip v-if="attendance.is_absence" class="vs-chip-danger text-white mt-2">
      Tidak Hadir
    </vs-chip>
    <vs-chip v-if="isNotClockOut" class="vs-chip-danger text-white mt-2">
      Tidak Absen Pulang
    </vs-chip>
  </div>
</template>

<script>
export default {
  props: {
    attendance: {
      type: Object,
      required: true
    }
  },
  computed: {
    isOnTime(){
      return !this.attendance.is_absence 
        && !this.attendance.is_late 
        && !this.attendance.is_early
        && this.attendance.end_time;
    },
    isNotClockOut(){
      let attendanceDate = new Date(this.attendance.created_at).toISOString().slice(0, 10).toString();
      let dateNow = new Date().toISOString().slice(0, 10).toString();
      
      if(attendanceDate != dateNow){
        return !this.attendance.is_absence && !this.attendance.end_time;
      } else {
        return false;
      }
    }
  }
};
</script>
